import currentSurveyReducer from "./currentsurvey"
import currentSurveyResultReducer from "./currentsurveyresult";
import selectedSectionAndPageReducer from "./selectedsectionandpage";
import surveysReducer from "./surveys";
import benchmarkedsReducer from "./benchmarkeds";
import organizationsReducer from "./organizations";
import userSurveysReducer from "./usersurveys";
import themeModeReducer from "./thememode";
import leftMenuWidthReducer from "./leftmenuwidth";
import rightMenuWidthReducer from "./rightmenuwidth";
import homeSelectedTabReducer from "./homeselectedtab";
import surveyDetailSelectedTabReducer from "./surveydetailselectedtab";
import leftMenuContentReducer from "./leftmenucontent";
import surveyRecipientsReducer from "./surveyrecipients";
import questionsReducer from "./questions";
import newQuestionReducer from "./newquestion";
import newSurveyReducer from "./newsurvey";
import resultsCurrentQuestionsReducer from "./resultscurrentquestions";
import { combineReducers } from "redux";
import leftMenuVisibilityReducer from "./leftmenuvisibilty";
import topMenuTabsReducer from "./topmenutabs";

const allReducers = combineReducers({
    currentSurvey: currentSurveyReducer,
    currentSurveyResult: currentSurveyResultReducer,
    selectedSectionAndPage: selectedSectionAndPageReducer,
    surveys: surveysReducer,
    benchmarkeds: benchmarkedsReducer,
    organizations: organizationsReducer,
    userSurveys: userSurveysReducer,
    themeMode: themeModeReducer,
    leftMenuWidth: leftMenuWidthReducer,
    rightMenuWidth: rightMenuWidthReducer,
    homeSelectedTab: homeSelectedTabReducer,
    surveyDetailSelectedTab: surveyDetailSelectedTabReducer,
    leftMenuContent: leftMenuContentReducer,
    surveyRecipients: surveyRecipientsReducer,
    questions: questionsReducer,
    newQuestion: newQuestionReducer,
    newSurvey: newSurveyReducer,
    resultsCurrentQuestions: resultsCurrentQuestionsReducer,
    leftMenuVisibility:leftMenuVisibilityReducer,
    topMenuTabs: topMenuTabsReducer
});

export default allReducers;